import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of, } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef, Optional, } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { datePickerMinDate } from '../../shared/constants';
import { catchError, tap } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import Swal from 'sweetalert2';
import { slideInAnimation } from '../../animations/route-animation';
import { addMonths } from 'date-fns';
import { NavbarComponent } from '../../navbar/navbar.component';

@Component({
	selector: 'app-billing-list',
	templateUrl: './billing-list.component.html',
	styleUrl: './billing-list.component.scss',
	animations: [
		trigger('fadeInOut', [
			state('void', style({
				opacity: 0
			})),
			transition(':enter, :leave', [
				animate(500)
			])
		]),
		slideInAnimation
	]
})
export class BillingListComponent implements OnInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/list-appointment",
			name: "Appointment List"
		}
	];
	uId: any = null;
	caseDetails: any = {};
	pageLoading1 = false;
	pageLoading2 = false;
	pageLoading3 = false;
	billingList: any[] = [];
	billingListUSD: any[] = [];
	pagetitle: string = "Invoices";
	checkAll = false;
	activeTab: any = 0;
	moduleForm: FormGroup = this.formBuilder.group({
		usd_invoice_number: [null, [Validators.required]],
		usd_conversion_rate: [null, [Validators.required, Validators.pattern(/^[+-]?([0-9]*[.])?[0-9]+$/)]],
		usd_invoice_date: [new Date(), [Validators.required]],
		usd_due_date: [addMonths(new Date(), 1), [Validators.required]],
		usd_bill_flag: [false, [Validators.required]],
		usd_paid_flag: [false, [Validators.required]],
		id: [null]
	});
	convertLoader = false;
	minDate = datePickerMinDate;
	formSubmitted = false;
	/* line_items: any[] = []; */
	followUpBillsData: any[] = [];
	loadingBilling = false;
	billingFilter = "All";
	billingFilterList = ["All", "Billed", "Unbilled"];
	followupList: any = [];
	caseReminder: any = null;
	billing_status: number = 0;

	showBillRow(bill: any) {
		let matched = false;
		if (this.billingFilter == "All") {
			matched = true;
		}
		if (this.billingFilter == "Billed" && bill.used_in_invoice) {
			matched = true;
		}
		if (this.billingFilter == "Unbilled" && !bill.used_in_invoice) {
			matched = true;
		}
		return matched;
	}

	constructor(private router: Router, private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) { }
	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["uId"] == undefined ? null : routeParams["uId"];
			this.breadcrumbList.push({ path: "/app/appt-details/no/" + this.uId + "/empty", name: "Appointment Details" });
			this.breadcrumbList.push({ path: "/app/case-invoice/" + this.uId, name: "Invoices" });
			this.getCaseDetails();
			this.getFollowup();
			this.getCaseReminders();
		});
	}

	get f() { return this.moduleForm.controls; }

	getFollowup() {
		this.apiService.getFollowupList({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.followupList = data.data;
			}, error: (error) => {
				this.followupList = [];
			},
		});
	}

	getCaseReminders() {
		this.apiService.getCaseReminders(this.uId).subscribe({
			next: (data: any) => {
				this.caseReminder = data;
			}, error: (error) => {
				this.caseReminder = null;
				this.toastr.error(error.error, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	getCaseDetails() {
		this.pageLoading1 = true;
		this.apiService.getUpdateCaseDetails({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.caseDetails = data;
				this.billing_status = this.caseDetails.billing_status;
				this.getBothInvoices();
				this.getFolloupBillsByCase();
			}, error: (error) => {
				this.pageLoading1 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getBothInvoices() {
		this.getBilllingList();
		this.getBilllingListUSD();
	}

	getBilllingList() {
		this.pageLoading2 = true;
		this.apiService.invoiceListByCase({ "id": this.caseDetails.id }).subscribe({
			next: (data: any) => {
				this.pageLoading2 = false;
				this.billingList = data.data;
			}, error: (error) => {
				this.pageLoading2 = false;
				this.billingList = [];
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getBilllingListUSD() {
		this.pageLoading3 = true;
		this.apiService.invoiceListByCaseUSD({ "id": this.caseDetails.id }).subscribe({
			next: (data: any) => {
				this.pageLoading3 = false;
				this.billingListUSD = data.data;
			}, error: (error) => {
				this.pageLoading3 = false;
				this.billingListUSD = [];
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	checkUncheckAll() {
		for (let i = 0; i < this.billingList.length; i++) {
			if (this.billingList[i].is_usd_done) {
				this.billingList[i].checked = false;
			} else {
				this.billingList[i].checked = this.checkAll;
			}
		}
	}

	billChecked() {
		let allChecked = true;
		for (let i = 0; i < this.billingList.length; i++) {
			if (!this.billingList[i].checked && !this.billingList[i].is_usd_done) {
				allChecked = false;
			}
		}
		this.checkAll = allChecked;
	}

	getTabClass(num: any) {
		if (this.activeTab == num) {
			return "active";
		} else {
			return "";
		}
	}

	getTabPaneClass(num: any) {
		if (this.activeTab == num) {
			return "tab-pane active";
		} else {
			return "tab-pane";
		}
	}

	setActiveTab(num: any) {
		this.activeTab = num;
		if (num == 0) {
		} else if (num == 1) {
		} else if (num == 2) { }
	}

	getFolloupBillsByCase() {
		if (this.caseDetails.id) {
			this.loadingBilling = true;
			this.apiService.getFolloupBillsByCase({ id: this.caseDetails.id }).subscribe({
				next: (data: any) => {
					data.data.map((bill: any) => {
						bill.files = bill.files === null ? [] : bill.files;
						bill.gpay_files = bill.gpay_files === null ? [] : bill.gpay_files;
						bill.qrcode_files = bill.qrcode_files === null ? [] : bill.qrcode_files;
						return bill
					});
					this.loadingBilling = false;
					this.followUpBillsData = data.data;
				}, error: (error) => {
					this.loadingBilling = false;
					this.followUpBillsData = [];
				}
			})
		}
	}

	openConvertModal(isEdit: boolean, index: any) {
		if (isEdit) {
			$("#convertModal").modal("show");
			this.moduleForm.setValue({
				usd_invoice_number: this.billingListUSD[index].usd_invoice_number,
				usd_conversion_rate: this.billingListUSD[index].usd_conversion_rate,
				usd_invoice_date: this.apiService.getDateFromDateString(this.billingListUSD[index].usd_invoice_date),
				usd_due_date: this.apiService.getDateFromDateString(this.billingListUSD[index].usd_due_date),
				usd_bill_flag: this.billingListUSD[index].usd_bill_flag,
				usd_paid_flag: this.billingListUSD[index].usd_paid_flag,
				id: this.billingListUSD[index].id
			});
			/* this.line_items = JSON.parse(JSON.stringify(this.billingListUSD[index].line_items)); */
			this.usdBillFlagChanged();
		} else {
			let noneSelected = true;
			for (let i = 0; i < this.billingList.length; i++) {
				if (this.billingList[i].checked && !this.billingList[i].is_usd_done) {
					noneSelected = false;
				}
			}
			if (noneSelected) {
				this.toastr.error("Please select bill.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			} else {
				$("#convertModal").modal("show");
			}
		}
	}

	closeConvertModal() {
		this.moduleForm.setValue({
			usd_invoice_number: null,
			usd_conversion_rate: null,
			usd_invoice_date: new Date(),
			usd_due_date: addMonths(new Date(), 1),
			usd_bill_flag: false,
			usd_paid_flag: false,
			id: null
		});
		this.formSubmitted = false;
		this.moduleForm.markAsPristine();
		this.moduleForm.markAsUntouched();
		$("#convertModal").modal("hide");
	}

	convertToUSD() {
		this.formSubmitted = true;
		if (this.moduleForm.invalid) {
			this.toastr.error("Please check required fields", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let line_items: any[] = [];
		if (!this.f.id.value) {
			for (let i = 0; i < this.billingList.length; i++) {
				if (this.billingList[i].checked && !this.billingList[i].is_usd_done) {
					line_items.push(this.billingList[i].id);
				}
			}
		}/*  else {
			line_items = JSON.parse(JSON.stringify(this.line_items));
		} */
		let payload = {
			line_items: line_items,
			usd_invoice_number: this.f.usd_invoice_number.value,
			usd_conversion_rate: this.f.usd_conversion_rate.value,
			usd_bill_flag: this.f.usd_bill_flag.value,
			usd_paid_flag: this.f.usd_paid_flag.value,
			usd_invoice_date: this.apiService.getDateStringFromDate(this.f.usd_invoice_date.value),
			usd_due_date: this.apiService.getDateStringFromDate(this.f.usd_due_date.value),
			id: this.f.id.value,
			case_id: this.caseDetails.id
		}
		this.convertLoader = true;
		this.apiService.createUpdateUSDInvoice(payload).subscribe({
			next: (data: any) => {
				this.convertLoader = false;
				this.closeConvertModal();
				this.toastr.success("Saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.checkAll = false;
				this.getBothInvoices();
			}, error: (error) => {
				this.convertLoader = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	billedOrPaidToggleChanged(index: number) {
		let usd_invoice_date: any = null;
		try {
			usd_invoice_date = this.billingListUSD[index].usd_invoice_date.split("-").reverse().join("-");
		} catch (error) { }
		let usd_due_date: any = null;
		try {
			usd_due_date = this.billingListUSD[index].usd_due_date.split("-").reverse().join("-");
		} catch (error) { }

		let payload = {
			line_items: [],
			usd_invoice_number: this.billingListUSD[index].usd_invoice_number,
			usd_conversion_rate: this.billingListUSD[index].usd_conversion_rate,
			usd_bill_flag: this.billingListUSD[index].usd_bill_flag,
			usd_paid_flag: this.billingListUSD[index].usd_paid_flag,
			usd_invoice_date: usd_invoice_date,
			usd_due_date: usd_due_date,
			id: this.billingListUSD[index].id,
			case_id: this.caseDetails.id
		}
		this.apiService.createUpdateUSDInvoice(payload).subscribe({
			next: (data: any) => {
				this.toastr.success("Saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getBilllingListUSD();
			}, error: (error) => {
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showDeleteLoader: any = null;
	deleteConfirm(uId: any) {
		Swal.fire({
			title: 'Warning',
			text: 'Are you sure you want to delete bill?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#f23022'
		}).then((result) => {
			if (result.value) {
				this.showDeleteLoader = uId;
				this.apiService.deleteInvoice({ id: uId }).subscribe({
					next: data => {
						this.showDeleteLoader = null;
						Swal.fire('Success', 'Bill deleted successfully.', 'success');
						this.getBothInvoices();
					}, error: (error) => {
						this.showDeleteLoader = null;
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			}
		})
	}

	showDeleteLoaderUSD: any = null;
	deleteConfirmUSD(uId: any) {
		Swal.fire({
			title: 'Warning',
			text: 'Are you sure you want to delete bill?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#f23022'
		}).then((result) => {
			if (result.value) {
				this.showDeleteLoaderUSD = uId;
				this.apiService.deleteUSDInvoice({ id: uId }).subscribe({
					next: data => {
						this.showDeleteLoaderUSD = null;
						Swal.fire('Success', 'Bill deleted successfully.', 'success');
						this.getBothInvoices();
					}, error: (error) => {
						this.showDeleteLoaderUSD = null;
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			}
		})
	}

	usdBillFlagChanged() {
		if (this.f.usd_bill_flag.value) {
			this.f.usd_paid_flag.enable();
		} else {
			this.f.usd_paid_flag.disable();
		}
	}

	validateForCaseClosure() {
		let msgList = this.validateForReadyToBill();
		if (!this.caseDetails.ready_to_bill) {
			msgList.push('<li>Ensure case is marked as <strong>"Ready to bill"<strong></li>')
		}
		return msgList;
	}

	validateForReadyToBill() {
		let msgList: string[] = this.validateForMarkForClosure();
		if (!this.caseDetails.mark_for_closure) {
			msgList.push('<li>Ensure case is marked as <strong>"Marked for closure"</strong></li>');
		}
		let len = this.followUpBillsData.length;
		for (let i = 0; i < len; i++) {
			if (!this.followUpBillsData[i].files.length || !this.followUpBillsData[i].gpay_files.length || !this.followUpBillsData[i].is_paid) {
				msgList.push("<li>Ensure Billing is completed for all followups</li>");
				break;
			}
		}
		return msgList;
	}

	validateForMarkForClosure() {
		let msgList: string[] = [];
		if (this.caseReminder.crew_details_not_filled) {
			msgList.push("<li>Ensure all crew details are filled</li>");
		}
		if (this.caseReminder.data_not_filled) {
			msgList.push("<li>Ensure key evaluations are filled</li>");
		}
		if (this.caseReminder.files_not_uploaded.length) {
			msgList.push("<li>Upload all missing files under follow-ups</li>");
		}
		for (let i = 0; i < this.followupList.length; i++) {
			if (
				this.followupList[i].follow_up_status?.id == 1
			) {
				msgList.push("<li>Ensure all follow-ups are completed</li>");
				break;
			}
		}
		return msgList;
	}

	billStLoader = false;
	billingStatusChanged() {
		let msgList = this.validateForCaseClosure();
		if (this.billing_status == 2 && msgList.length) {
			let str = '<p class="mb-0">To enable <strong>"Final Billing"</strong> make sure following actions are completed</p>';
			str += "<ol>"
			str += msgList.join("");
			str += "</ol>"
			Swal.fire({
				title: 'Please confirm',
				html: str,
				icon: 'question'
			})
			setTimeout(() => {
				this.billing_status = this.caseDetails.billing_status;
			}, 100);
		} else {
			/* const status_id = this.billing_status == 2 ? 2 : 1; */
			this.billStLoader = true;
			this.apiService.updateCaseDetails({ id: this.uId, billing_status: this.billing_status/* , status_id: status_id */ }).subscribe({
				next: (data: any) => {
					this.billStLoader = false;
					this.toastr.success('Updated successfully', 'Success', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
					this.getCaseDetails();
				}, error: (error) => {
					this.billStLoader = false;
					this.toastr.error('Something went wrong', 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				},
			});
		}
	}

	copyLoader: any = null;
	copyInvLinkToClipboard(inv: any, type: string) {
		const path = type == "INR" ? inv.invoice_path : inv.usd_invoice_path;
		if (path) {
			let link = environment.File_Storage_URL + path;
			navigator.clipboard.writeText(link).then(() => {
				this.toastr.success("Link copied to clipboard.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}).catch(err => {
				this.toastr.error("Unable to copy", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			});
		} else {
			this.copyLoader = inv.enc_id;
			if (type == "INR") {
				this.apiService.invoicePDFINR({ id: inv.enc_id }).subscribe({
					next: (data: any) => {
						this.apiService.getInvoiceDetails({ id: inv.enc_id }).subscribe({
							next: (data: any) => {
								this.copyLoader = null;
								inv.invoice_path = data.data.invoice_path;
								this.copyInvLinkToClipboard(inv,"INR");
							}, error: (error) => {
								this.copyLoader = null;
								this.toastr.error('Something went wrong', 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							}
						});
					}, error: (error) => {
						this.copyLoader = null;
						this.toastr.error('Something went wrong', 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			} else {
				this.apiService.invoicePDFUSD({ id: inv.enc_id }).subscribe({
					next: (data: any) => {
						this.apiService.getInvoiceDetails({ id: inv.enc_id }).subscribe({
							next: (data: any) => {
								this.copyLoader = null;
								inv.usd_invoice_path = data.data.usd_invoice_path;
								this.copyInvLinkToClipboard(inv,"USD");
							}, error: (error) => {
								this.copyLoader = null;
								this.toastr.error('Something went wrong', 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							}
						});
					}, error: (error) => {
						this.copyLoader = null;
						this.toastr.error('Something went wrong', 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}
}
